import { Button, Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@hub-la/shadcn'
import { DialogTrigger } from '@radix-ui/react-dialog'
import { X } from 'lucide-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ReceiverStatus } from '../../../domain/enums/receiver-status'
import { useUpdateReceiverStatus } from '../../hooks/use-update-receiver-status'

type RejectInviteProps = {
  receiverId: string
  onChange?: () => void
}

export const RejectInvite = ({ receiverId, onChange }: RejectInviteProps) => {
  const [open, setOpen] = useState<boolean>(false)

  const { t } = useTranslation()
  const { mutateAsync: updateStatus, isLoading } = useUpdateReceiverStatus()

  const handleReject = async () => {
    await updateStatus({ id: receiverId, status: ReceiverStatus.REJECTED })
    onChange?.()
    setOpen(false)
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="outline" size="sm">
          <X className="w-4 h-4 mr-1" />
          {t('partnerships.reject')}
        </Button>
      </DialogTrigger>

      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>{t('partnerships.rejectInvite.title')}</DialogTitle>
        </DialogHeader>

        <DialogFooter className="sm:space-x-4 flex flex-col-reverse sm:flex-row justify-end items-center">
          <Button variant="outline" onClick={() => setOpen(false)}>
            {t('partnerships.back')}
          </Button>

          <Button variant="outline" onClick={handleReject} loading={isLoading}>
            {t('partnerships.reject')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
